// extracted by mini-css-extract-plugin
export default {"control":"control_control__3noB2","button":"control_button__6DcJP","icon":"control_icon__oD+JE"};